<template>
  <div class=" px-4 justify-center max-w-[1000px] max-h-[600px] flex  flex-col gap-2">
    <div class="justify-center flex   ">
      <span class="text-sm" v-html="value.message"></span>
    </div>

    <div class="flex ">
      <span class="p-1 w-[150px]">Artikelnummer:</span>
      <input data-ui="add-article-number"
             class="cursor-grab outline-0 border border-bg-trader-input-border border-header p-1 w-full  shadow-inner-2 text-gray-500 mr-1"
             v-model="articleNumber">
    </div>
    <!--
        <div class="grid-cols-12 grid  overflow-auto" v-if="value.marketId != 0">
          <div v-for="market in marketList" :key="market.marketId" class=" ">
            <div class="bg-trader-gray p-4 m-2 flex">
              <span class="mr-2">{{ market.name }}</span>
              <input type="checkbox" @click="getMarketIds(market.marketId)" :checked="marketIds.includes(market.marketId)">
            </div>
          </div>
        </div>
        -->
    <div class="flex overflow-auto p-2 gap-2">
      <div class="flex flex-col gap-2" v-for="(placeHolderMarket, index) in placeHolderMarkets"
           :key="placeHolderMarket.marketId">
        <div class="flex flex-col gap-1">
          <div v-if="placeHolderMarket.marketId !== 0" class="p-2 bg-trader-gray h-[35px] w-full text-center ">
            {{ placeHolderMarket.marketName }}
          </div>
          <div v-if="placeHolderMarket.marketId === 0" class="p-2 bg-trader-gray w-full text-center ">Kein Markt</div>
          <div class="flex " v-for="placeHolder in placeHolderMarket.placeholders "
               :key="placeHolder.placeholderId">
            <div class=" flex  bg-trader-gray w-[85px] h-[35px]  justify-center items-center" >
              <div class=" w-full p-2 flex justify-between ">
                <span class="">{{ placeHolder.productPosition }}</span>
                <input @click="toggleCheckbox(placeHolderMarket.marketId, placeHolder.placeholderId)" :data-ui="'checkbox-' + placeHolderMarket.marketId + '-' + index"
                       class="outline-0 border border-bg-trader-input-border border-header shadow-inner-2 text-gray-500"
                       type="checkbox" :checked="isChecked(placeHolderMarket.marketId, placeHolder.placeholderId)">
              </div>
              <div class="p-2 bg-trader-gray flex gap-2 justify-center items-center"
                   v-for="purchaser in placeHolder.purchaser" :key="purchaser.id">

                <span v-if="purchaser.id !== 0" v-html="teamIcon(purchaser.id)"></span>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-2 p-2 ">
      <div class="w-full flex gap-2 ">
        <button class="bg-trader-gray w-full rounded p-2 " @click="selectAllMarkets" data-ui="select-all-markets">
          Alle möglichen Märkte auswählen
        </button>
        <button class="bg-trader-gray w-full rounded p-2 " @click="deselectAllMarkets" data-ui="deselect-all-markets">
          Alle Märkte abwählen
        </button>
      </div>
      <div class="w-full flex gap-2 ">
        <button class="bg-trader-green w-full rounded p-2 " @click="placeProductOnMarket"
                data-ui="place-product-on-market">
          Speichern
        </button>
        <button class="bg-trader-gray w-full rounded p-2 " @click="deleteFalse" data-ui="delete-no">Abbrechen
        </button>
      </div>
    </div>

  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import {eventBus} from "@/application/EventBus.js";
import {mapGetters} from "vuex";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      articleNumber: "",
      marketList: [],
      magazineId: 0,
      pagePosition: 0,
      marketIds: [],
      placeHolderMarkets: [],
      selectedPlaceholders: {}
    }
  },
  mounted() {
    this.getMarkets();
    this.getPlaceholdersForMarkets();
  },
  created() {
    this.getMarkets();
    this.getPlaceholdersForMarkets();
  },
  computed: {
    ...mapGetters('team', ['teamIcon']),
  },

  methods: {

    toggleCheckbox(marketId, placeholderId) {
      const newSelections = {...this.selectedPlaceholders};
      if (newSelections[marketId] === placeholderId) {
        delete newSelections[marketId];
      } else {
        newSelections[marketId] = placeholderId;
      }
      this.selectedPlaceholders = newSelections;
    },
    isChecked(marketId, placeholderId) {
      return this.selectedPlaceholders[marketId] === placeholderId;
    },
    numberToAlphabetChar(zahl) {
      let buchstaben = "";
      while (zahl > 0) {
        let modulo = (zahl - 1) % 26;
        buchstaben = String.fromCharCode(97 + modulo) + buchstaben; // 97 ist der ASCII-Wert von 'a'
        zahl = Math.floor((zahl - modulo) / 26);
      }
      return buchstaben;
    },
    selectAllMarkets() {
      const newSelections = {};
      this.placeHolderMarkets.forEach(market => {
        if (market.placeholders.length > 0) {
          newSelections[market.marketId] = market.placeholders[0].placeholderId;
        }
      });
      this.selectedPlaceholders = newSelections;
    },
    deselectAllMarkets() {
      this.selectedPlaceholders = {};
    },
    async placeProductOnMarket() {
      const selectedPlaceholdersArray = [];

      for (const marketId in this.selectedPlaceholders) {
        const placeholderId = this.selectedPlaceholders[marketId];
        selectedPlaceholdersArray.push({marketId: parseInt(marketId), placeholderId: placeholderId});
      }
      const data = {
        articleNumber: this.articleNumber,
        magazineId: this.value.magazineId,
        pagePosition: this.value.pagePosition,
        placeHolderMarkets: selectedPlaceholdersArray
      }

      // schreibe die Daten in die Datenbank
      const mutation = gql`
        mutation placeProductOnMarket($data: PlaceProductOnMarketInput!) {
            placeProductOnMarket(data: $data) {
              articleNumber
              code
              marketIds
              success
           }
        }
      `;
      const variables = {
        data: data
      };
      try {

        const {data} = await apolloClient.mutate({mutation, variables});

        if (data.placeProductOnMarket.code === "NO_SPACE_FOR_THIS_PRODUCT") {
          this.value.productCanNotBePlaced(data.placeProductOnMarket.marketIds, this.articleNumber);

        } else {
          eventBus.closeModal();
        }
        if (data.placeProductOnMarket.success) {
          this.value.onSuccess();
        }
      } catch (error) {
        console.error(error);
      }
    },
    getMarketIds(marketId) {
      if (!this.marketIds.includes(marketId)) {
        this.marketIds.push(marketId);
      } else {
        this.marketIds = this.marketIds.filter(item => item !== marketId);
      }
    },
    async getMarkets() {
      const query = gql`
        query getMarketsStatus($magazineId: Int!, $pagePosition: Int!) {
          getMarketsStatus(magazineId: $magazineId, pagePosition: $pagePosition)  {
            marketId
            name
            description
            isActive
            isFull
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({
          query,
          variables: {magazineId: this.value.magazineId, pagePosition: this.value.pagePosition}
        });
        this.marketList = data.getMarketsStatus;

      } catch (error) {
        console.error(error);
      }

    },
    async getPlaceholdersForMarkets() {
      const query = gql`
        query getPlaceholdersForMarkets($magazineId: Int!, $pagePosition: Int!) {
          getPlaceholdersForMarkets(magazinId: $magazineId, pagePosition: $pagePosition)  {
            marketId
            marketName
            placeholders {
              placeholderId
              isEmpty
              productPosition
                purchaser{
                  name
                  teamIcon
                  color
                  id
                }
            }
          }
        }
      `;
      try {
        const {data} = await apolloClient.query({
          query,
          variables: {
            magazineId: this.value.magazineId,
            pagePosition: this.value.pagePosition
          }

        });
        this.placeHolderMarkets = data.getPlaceholdersForMarkets;

        // order by marketId
        this.placeHolderMarkets.sort((a, b) => a.marketName - b.marketName);

        if (this.placeHolderMarkets.marketId !== 0) {
          // entferne alle wo isEmpty == false auch den ganzen Markt
           this.placeHolderMarkets.filter(placeholder => {
           // rmove all placeholders where isEmpty == false
            placeholder.placeholders = placeholder.placeholders.filter(placeholder => placeholder.isEmpty === true);
          });
        }

      } catch (error) {
        console.error(error);
      }

    },

    deleteTrue() {
      eventBus.closeModal();

      try {
        if (this.value.onAccept) {
          this.value.onAccept();
        }
      } catch (e) {
      }

    },
    deleteFalse() {
      eventBus.closeModal();

      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
      }


    }
  }
  ,


}


</script>

